import React, { useState, useEffect } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    TextField,
    FormControl
} from "@material-ui/core";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { DownloadOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import HttpService from "../../services/httpService";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 850,
    },
    textField: {
        width: 100,
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 400,
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500",
        // border: '1px solid black'
    },
    body: {
        fontSize: 14,
        // border: '1px solid red'
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const POEditRequests = (props) => {
    const classes = useStyles();
    const [poEditApprovalRequestData, setPoEditApprovalRequestData] = useState([]);
    const [selectedOrderId, setSelectedOrderId] = useState("");
    const [details, setDetails] = useState([]);
    const [textContent, setTextContent] = useState("");
    const [procurementDetails, setProcurementDetails] = useState({});
    const [invoiceModal, setInvoiceModal] = useState(false);
    const [value, setValue] = useState("");
    const [freightCharge, setFreightCharge] = useState(0);
    const [gstAmounts, setGstAmounts] = useState(0);
    const [transportationCharge, setTransportationCharge] = useState(0);
    const [editableFields, setEditableFields] = useState({
        transportationCharge: transportationCharge,
        gstAmounts: gstAmounts,
        freightCharge: freightCharge,
    });
    const [material, setMaterial] = useState({});
    const [updatedMat, setUpdatedMat] = useState(0);
    const [openRemarksModal, setOpenRemarksModal] = useState(false);
    const [remarks, setRemarks] = useState("");

    // Function to get all request for PO Edit
    const getPOEditApprovalRequestData = async () => {
        props.setLoading(true);
        try {
            const response = await HttpService.getPOEditApprovalRequestData();
            setPoEditApprovalRequestData(response.data);
            // setDataToDisplay(response.data);
        } catch (err) {
            props.setSnackInfo(
                err?.response?.data ?? "Something went wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // Function to open invoice Modal
    const openInvoiceModalHelper = (materialId, data, value) => {
        setInvoiceModal(true);
        priceCal(materialId, data, value);
        setMaterial(
            procurementDetails?.materials?.filter(
                (material) => material?.materialId?._id === materialId
            )[0]
        );
        // setIndex(i)
    };

    // Function to Open Details of Request 
    const openInvoiceModalHandler = async (value) => {
        setInvoiceModal(true);
        setSelectedOrderId(value?.procurementId?.orderId);
        // setValue(value);
        setDetails(value);
        props.setLoading(true);
        try {
            const result = await HttpService.getProcurementByOrderIdForInwarding(
                value?.procurementId?.orderId
            );
            setProcurementDetails(result.data);
            let arr = result?.data?.materials?.map((el) => el.requestedPrice);
            // setMaterialOriginalPrice(arr);
            // setOpenDialog(true)
            openInvoiceModalHelper(
                value?.materialId?._id,
                result.data,
                value
            );
        } catch (error) {
            console.error(error);
            // props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false);
    };

    // A helper function to calculate the necessary fields when rate, gst, freight, or transportation charges are changed
    const priceCal = (materialId, data, value) => {
        let total = 0;
        let subTotal = 0;
        let presicionDiff = 0;
        let totalGstAmount = 0;
        let totalQty = 0;
        data.materials.forEach((mat) => {
            if (
                mat.materialId._id.toString() === materialId.toString() &&
                mat?.materialId?._id?.toString() ===
                value?.materialId?._id?.toString()
            ) {
                // mat.materialTotal = +mat.requestedQuantity * +mat.requestedPrice || +mat.materialId.pricePerUnit;
                mat.materialTotal = +value.inwardingRecordId?.InwardingRecords?.inwardedQty * +value.requestedMaterialPrice;
                total += +mat.materialTotal;
                // totalQty += mat.requestedQuantity;
                totalQty += +value?.inwardingRecordId?.InwardingRecords?.inwardedQty;
                mat.isAdded = true;
            }
        });

        if (data.discount) {
            // total = total - data.discount;
            let discountAmount = (data.discount / 100) * +total; // Calculate the discount amount
            total -= discountAmount;
        } else {
            data.discount = 0;
        }
        subTotal = +total;

        if (value?.requestedGSTDetails) {
            value?.requestedGSTDetails.forEach((gstDetail) => {
                gstDetail.gstAmount = Number(
                    Number.parseFloat((+gstDetail.gstRate * +total) / 100).toFixed(2)
                );
                totalGstAmount += gstDetail.gstAmount;
            });

            total = total + totalGstAmount;
        } else {
            totalGstAmount = 0;
        }

        if (value?.requestedFreightCharge) {
            total = +total + +value.requestedFreightCharge;
        } else {
            data.freight = 0;
        }

        if (data.transportationCharge) {
            total = total + data.transportationCharge;
        } else {
            data.transportationCharge = 0;
        }

        data.totalQty = +totalQty;
        data.subTotal = +subTotal;
        data.grandTotal = +total;
        presicionDiff =
            Math.round(total) -
            Number(Number.parseFloat(subTotal).toFixed(2)) -
            Number(Number.parseFloat(totalGstAmount).toFixed(2)) +
            Number(Number.parseFloat(data.discount).toFixed(2)) -
            Number(Number.parseFloat(data.transportationCharge).toFixed(2)) -
            Number(Number.parseFloat(data.freight).toFixed(2));
        data.presicionDiff = Number.parseFloat(presicionDiff).toFixed(2);
        // let word = numWords(Math.round(+procurementDetails.grandTotal));
        // procurementDetails.amountInWords = word.toUpperCase();
        setTransportationCharge(data?.transportationCharge);
        setFreightCharge(data?.freight);
        setGstAmounts(totalGstAmount);
        setEditableFields({ ...editableFields, gstAmounts: data?.gstDetails });
        setUpdatedMat(data.grandTotal);
        setProcurementDetails(data);
        return data;
    };

    // Function to Open Remarks Modal
    const openRemarksModalHandler = (status) => {
        if (status === "Approved") {
            setTextContent("Approval");
        }
        if (status === "Rejected") {
            setTextContent("Rejection");
        }
        setValue(status);
        setOpenRemarksModal(true);
    };

    // Funtion to close Remarks Modal
    const closeRemarksModalHandler = () => {
        setOpenRemarksModal(false);
        setRemarks("");
    };

    // Function to handle remarks input
    const remarksInputHandler = async (e) => {
        setRemarks(e.target.value);
        // if (e.target.value.trim() === "") return props.setSnackInfo("Please Enter Remarks", "error");
    };

    // Function to handle the PO Edit Request Approve/Reject
    const updatePOEditRequestStatus = async () => {
        props.setLoading(true);
        setOpenRemarksModal(false);
        try {
            if (remarks.trim().length === 0) {
                // props.setSnackInfo("Please enter remarks before submitting.", "warning");
                props.setSnackInfo(`Please Enter ${textContent} Remarks Before Submitting`, "warning");
                props.setLoading(false);
                return;
            }
            let payload = { status: value, remarks: remarks, poEditRequestId: details._id }
            const response = await HttpService.updatePOEditRequestStatus(payload);
            if(response?.data?.editedPoLink){
                window.open(response.data.editedPoLink);
            }
            props.setSnackInfo(response?.data?.msg ?? "Updated Successfully", response?.data?.type ?? "success");
        } catch (error) {
            console.error("Error -> ", error);
        }
        setRemarks("");
        setInvoiceModal(false);
        props.setLoading(false);
        getPOEditApprovalRequestData();
    }

    // Funtion to get type of the file do display
    const getFileType = (url) => {
        const extension = url?.split(".").pop()?.toLowerCase();
        if (extension === "pdf") {
            return "pdf";
        } else if (
            extension === "jpg" ||
            extension === "jpeg" ||
            extension === "png" ||
            extension === "gif"
        ) {
            return "image";
        } else {
            return "unknown";
        }
    };

    useEffect(() => {
        getPOEditApprovalRequestData();
    }, []);

    return (
        <div>
            <div
                style={{
                    marginBottom: 20,
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Paper className={classes.paper}>
                    <center>
                        <h2>Revised PO Approval for Rejected Inwarding</h2>
                    </center>
                </Paper>
            </div>

            {/* Table to Display the PO Edit Requests */}
            <TableContainer TableContainer component={Paper}>
                <Table
                    className={classes.table}
                    size="small"
                    aria-label="customized table"
                    stickyHeader
                >
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Sl No</StyledTableCell>
                            <StyledTableCell>PO No</StyledTableCell>
                            <StyledTableCell>Material Name</StyledTableCell>
                            <StyledTableCell>Requested By</StyledTableCell>
                            <StyledTableCell>View</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {poEditApprovalRequestData?.map((el, i) => {
                            return (
                                <StyledTableRow key={i + 1}>
                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                    <StyledTableCell>
                                        {el?.procurementId?.orderId}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.materialId?.name}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.createdBy?.name}
                                    </StyledTableCell>
                                    {/*
                                    <StyledTableCell>
                                        {el?.bomQuantity?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.bomStandardRate?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>{el?.bomValue?.toFixed(2)}</StyledTableCell>
                                    <StyledTableCell>
                                        {el?.poQuantity?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.poStandardRate?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>{el?.poValue?.toFixed(2)}</StyledTableCell>
                                    <StyledTableCell>
                                        {moment(el?.InwardingRecords?.dateOfInwarded).format(
                                            "DD-MM-YYYY"
                                        )}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.inwardedQty?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.inwardedRate?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.InwardingRecords?.inwardedValue?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.approvedQty?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.approvedRate?.toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {el?.approvedValue?.toFixed(2)}
                                    </StyledTableCell>
                                    */}
                                    <StyledTableCell>
                                        <>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => openInvoiceModalHandler(el)}
                                            >
                                                Action
                                            </Button>
                                        </>
                                    </StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Modal to show details for the editing requests */}
            <Modal
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                title={`Procurement Order | ${selectedOrderId}`}
                centered
                open={invoiceModal}
                onCancel={() => setInvoiceModal(false)}
                width={1500}
                maskClosable={true}
                footer={null}
            >
                <div style={{ display: "flex", width: "100%" }}>
                    <div style={{ border: "1px solid #000", flex: 1, padding: "2px" }}>
                        <div
                            className="container"
                            style={{ width: "100%", marginTop: "2%" }}
                        >
                            <div>
                                <div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td rowSpan="3" style={{ width: "50%" }}>
                                                    <div className="invoice">Invoice to:</div>
                                                    <div className="invoice-to">
                                                        <b>Decorpot Pvt Ltd.</b>
                                                        <div>
                                                            #17, 18th Cross Rd, Sector 3, HSR Layout,
                                                            Bengaluru - 560102
                                                        </div>
                                                        <div className="gstno">Gst No-29AAWCS3842H1ZO</div>
                                                        <div>State Name : Karnataka, Code : 29</div>
                                                        <div>E-Mail: sales@decorpot.com</div>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Voucher No.</div>
                                                    <div className="vou-no">
                                                        <b>{procurementDetails?.orderId}</b>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Dated:</div>
                                                    <div className="vou-no">
                                                        <b>
                                                            {moment(procurementDetails?.createdAt).format(
                                                                "DD-MM-YYYY"
                                                            )}
                                                        </b>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "25%" }}>&nbsp;</td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Mode/Terms of Payment</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "25%" }}>
                                                    <div>Supplier's Ref./Order No.</div>
                                                    <div className="vou-no">
                                                        <b>{procurementDetails?.orderId}</b>
                                                    </div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Other Reference(s)/Comments</div>
                                                    <div className="vou-no">
                                                        <b>{procurementDetails?.comment}</b>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td rowSpan="2" style={{ width: "50%" }}>
                                                    <div className="invoice">Supplier</div>
                                                    <div className="invoice-to">
                                                        <b>{procurementDetails?.vendorId?.name}</b>
                                                        <div>{procurementDetails?.vendorId?.address}</div>
                                                        <div className="row">
                                                            <div
                                                                className="col-md-2"
                                                                style={{ float: "left" }}
                                                            >
                                                                GSTIN/UIN
                                                            </div>
                                                            <div className="col-md-10">
                                                                :&nbsp;
                                                                {procurementDetails?.vendorId?.gstinNumber}
                                                            </div>
                                                            <div className="row">
                                                                <div
                                                                    className="col-md-2"
                                                                    style={{ float: "left" }}
                                                                >
                                                                    State Name
                                                                </div>
                                                                <div className="col-md-10">
                                                                    :&nbsp;Karnataka, Code : 29
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>Dispatch through</div>
                                                </td>
                                                <td>
                                                    <div>Destination</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="1">
                                                    <div>Terms of Delivery</div>
                                                </td>
                                                <td style={{ width: "25%" }}>
                                                    <div>Invoice No.</div>
                                                    <div className="vou-no">
                                                        <b>{details?.InwardingRecords?.invoiceNumber}</b>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div>
                                    <Table
                                        size="small"
                                        aria-label="custom pagination table"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Sl. No.</TableCell>
                                                <TableCell>
                                                    Description of Goods
                                                </TableCell>
                                                <TableCell>Due On</TableCell>
                                                <TableCell>
                                                    Inwarded Quantity
                                                </TableCell>
                                                {/* <TableCell>Inwarded Rate</TableCell> */}
                                                <TableCell>Edited Rate</TableCell>
                                                <TableCell>per</TableCell>
                                                <TableCell>Disc. %</TableCell>
                                                <TableCell>Amount</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableHead>
                                            {procurementDetails?.materials?.map(
                                                (material, index) =>
                                                    material.isAdded && (
                                                        <TableRow key={index}>
                                                            <TableCell>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell>
                                                                <div>
                                                                    <b>
                                                                        {
                                                                            material
                                                                                ?.materialId
                                                                                ?.code
                                                                        }
                                                                    </b>
                                                                </div>
                                                                <br />
                                                                <div className="desc">
                                                                    [
                                                                    {material
                                                                        ?.materialId
                                                                        ?.aliasName
                                                                        ? material
                                                                            ?.materialId
                                                                            ?.aliasName
                                                                        : material
                                                                            ?.materialId
                                                                            .name}
                                                                    ]
                                                                </div>
                                                                <br />
                                                                {material?.remark && (
                                                                    <div className="desc">
                                                                        {
                                                                            material?.remark
                                                                        }
                                                                    </div>
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                45 Days
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    details
                                                                        ?.inwardingRecordId?.InwardingRecords
                                                                        ?.inwardedQty
                                                                }
                                                            </TableCell>
                                                            {/* 
                                                            <TableCell>
                                                                {details?.InwardingRecords?.inwardedRate}
                                                            </TableCell>
                                                            */}
                                                            <TableCell>
                                                                {/* {material?.requestedPrice} */}
                                                                {/* {!editFields ? (
                                                                    material?.requestedPrice
                                                                ) : (
                                                                    <FormControl
                                                                        style={{
                                                                            width: 200,
                                                                        }}
                                                                    >
                                                                        <TextField
                                                                            style={{
                                                                                margin: "5px",
                                                                            }}
                                                                            size="small"
                                                                            id={`requestedPrice-${index}`}
                                                                            label="Requested Price"
                                                                            value={
                                                                                material?.requestedPrice
                                                                            }
                                                                            variant="outlined"
                                                                            name={`requestedPrice-${index}`}
                                                                            type="number"
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                materialPriceChangeHandler(
                                                                                    index,
                                                                                    e
                                                                                )
                                                                            }
                                                                        />
                                                                    </FormControl>
                                                                )} */}
                                                                {details?.requestedMaterialPrice}
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    material
                                                                        ?.unitId
                                                                        .name
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {
                                                                    procurementDetails?.discount
                                                                }
                                                            </TableCell>
                                                            {/* <TableCell >₹{material?.materialTotal?.toFixed(2)}</TableCell> */}
                                                            <TableCell>
                                                                ₹
                                                                {(
                                                                    material?.materialTotal?.toFixed(
                                                                        2
                                                                    ) -
                                                                    (procurementDetails?.discount *
                                                                        material?.materialTotal) /
                                                                    100
                                                                ).toFixed(2)}
                                                            </TableCell>
                                                            {/* <TableCell>{(material?.materialTotal?.toFixed(2))} - {((procurementDetails?.discount * material?.materialTotal) / 100).toFixed(2)} = ₹{(material?.materialTotal?.toFixed(2) - (procurementDetails?.discount * material?.materialTotal) / 100).toFixed(2)}</TableCell> */}
                                                        </TableRow>
                                                    )
                                            )}
                                        </TableHead>
                                    </Table>
                                </div>

                                <div>
                                    <Table>
                                        <TableBody>
                                            <TableRow key="1">
                                                <TableCell>Total Qty</TableCell>
                                                <TableCell>{procurementDetails?.totalQty}</TableCell>
                                            </TableRow>
                                            <TableRow key="3">
                                                <TableCell>
                                                    <i>Freight Charge</i>
                                                </TableCell>
                                                <TableCell>
                                                    {/* 
                                                    <FormControl style={{ width: 300 }}>
                                                        <TextField
                                                            style={{ margin: "5px" }}
                                                            size="small"
                                                            id="outlined-basic"
                                                            label="Freight Charge"
                                                            value={freightCharge}
                                                            variant="outlined"
                                                            name="freight charge"
                                                            type="number"
                                                        // onChange={(e) => freightChargesChangeHandler(e)}
                                                        />
                                                    </FormControl>
                                                    */}
                                                    {details?.requestedFreightCharge}
                                                </TableCell>
                                            </TableRow>
                                            {/*
                                            <TableRow key="4">
                                                <TableCell>
                                                    <i>Transportation Charge</i>
                                                </TableCell>
                                                <TableCell>
                                                    <FormControl style={{ width: 300 }}>
                                                        <TextField
                                                            style={{ margin: "5px" }}
                                                            size="small"
                                                            id="outlined-basic"
                                                            label="Transportation Charge"
                                                            // value={transportationCharge}
                                                            variant="outlined"
                                                            name="Transportation Charge"
                                                            type="number"
                                                        // onChange={(e) =>
                                                        //     transportationChargesChangeHandler(e)
                                                        // }
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            */}
                                            <TableRow key="2">
                                                <TableCell>
                                                    <i>Gst Rate</i>
                                                </TableCell>
                                                <TableCell>{details?.requestedGSTDetails?.length > 0 ? details?.requestedGSTDetails[0]?.gstRate : "N/A"}%</TableCell>
                                            </TableRow>
                                            <TableRow key="5">
                                                <TableCell>
                                                    <i>Gst Amount</i>
                                                </TableCell>
                                                <TableCell>
                                                    {/*
                                                    <FormControl style={{ width: 300 }}>
                                                        <TextField
                                                            style={{ margin: "5px" }}
                                                            size="small"
                                                            id="outlined-basic"
                                                            label="Gst Charge"
                                                            // value={gstAmounts}
                                                            variant="outlined"
                                                            name="Gst Charge"
                                                            type="number"
                                                        // onChange={(e) => gstChangeHandler(e)}
                                                        />
                                                    </FormControl>
                                                    */}
                                                    {gstAmounts}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key="6">
                                                <TableCell>Total Amount</TableCell>
                                                <TableCell>
                                                    {/* ₹{Math.round(procurementDetails?.grandTotal)} */}
                                                    ₹{procurementDetails?.grandTotal?.toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div style={{ border: "1px solid #000", flex: 1, padding: "" }}>
                        {
                            // Display pdf when file type is pdf
                            getFileType(details?.InwardingRecords?.invoice) === "pdf" ? (
                                <iframe
                                    title="PDF Viewer"
                                    src={`https://docs.google.com/gview?url=${details?.InwardingRecords?.invoice}&embedded=true`}
                                    style={{
                                        width: "fit-content",
                                        height: "800px",
                                        border: "none",
                                    }}
                                ></iframe>
                            ) : // Display image when file is image
                                getFileType(details?.InwardingRecords?.invoice) === "image" ? (
                                    <img
                                        src={details?.InwardingRecords?.invoice}
                                        width="100%"
                                        alt="Image"
                                    ></img>
                                ) : (
                                    // Display warning when file type is not supported
                                    <p style={{ color: "red", padding: "10%" }}>
                                        <b>File Format Not Supported</b>
                                    </p>
                                )
                        }
                    </div> */}
                    {/* Second Display Box for Pdf */}
                    <div style={{ border: '1px solid #000', flex: 1, padding: "" }}>
                        {/* <iframe src={procurementDetails?.poLink} width="100%" ></iframe> */}
                        <iframe
                            title="PDF Viewer"
                            src={`https://docs.google.com/gview?url=${procurementDetails?.poLink}&embedded=true`}
                            // style={{ width: 'fit-content', height: '800px', border: 'none' }}
                            style={{ width: '100%', height: '800px', border: 'none' }}
                        ></iframe>
                    </div>
                </div>

                <DialogActions>
                    <Button
                        onClick={() => openRemarksModalHandler("Rejected")}
                        color="secondary"
                        variant="outlined"
                    >
                        Reject
                    </Button>
                    <Button
                        onClick={() => openRemarksModalHandler("Approved")}
                        color="primary"
                        variant="contained"
                        style={{ background: "#2b7636", margin: 5 }}
                    >
                        Approve
                    </Button>
                </DialogActions>
            </Modal>


            <div>
                <Dialog
                    open={openRemarksModal}
                    onClose={closeRemarksModalHandler}
                    aria-labelledby="form-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogContent>
                        <DialogContentText>Enter {textContent} Remarks</DialogContentText>
                        <TextField
                            id="remarks"
                            name="Remarks"
                            label="Add Remarks"
                            variant="outlined"
                            type="text"
                            value={remarks}
                            onChange={remarksInputHandler}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={closeRemarksModalHandler}
                            color="secondary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={updatePOEditRequestStatus}
                            variant="contained"
                            color="primary"
                            style={{ background: "#2b7636", margin: 5 }}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(
    POEditRequests
);